module.exports = __webpack_public_path__ + "static/media/alex_west_map_3_fields_left.577631a3.png";